import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import PDFViewer from '.';
import { usePDFViewer } from './usePDFViewer';
const PDFViewHelperView = ({}) => {
    const [{}] = useTheme(stylesGenerator);
    const [pdfViewerState, pdfViewerActions] = usePDFViewer();
    return (React.createElement(PDFViewer, { ...pdfViewerState, onClose: pdfViewerActions.hide }));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default PDFViewHelperView;
